module.exports = __webpack_public_path__ + "static/media/ax.184aa344.svg";